// extracted by mini-css-extract-plugin
export var addButton = "_c9-0";
export var border = "_c9-8";
export var check = "_c9-h";
export var danger = "_c9-6";
export var dropdownContainer = "_c9-1";
export var editModalBody = "_c9-j";
export var footerContainer = "_c9-i";
export var fullWidth = "_c9-a";
export var hide = "_c9-9";
export var icon = "_c9-3";
export var input = "_c9-7";
export var inputFlex = "_c9-b";
export var inputWrapper = "_c9-c";
export var manualFocus = "_c9-5";
export var optionButton = "_c9-4";
export var pillWrapper = "_c9-e";
export var pointer = "_c9-2";
export var showOverflow = "_c9-f";
export var tagsFlex = "_c9-d";
export var xButton = "_c9-g";